var _a;
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { COLUMNS_NAME } from '../../../constants';
export var listTableMapping = (_a = {},
    _a[COLUMNS_NAME.LIST_NAME] = React.createElement(FormattedMessage, { id: "ui-lists.lists.columns.list-name" }),
    _a[COLUMNS_NAME.RECORD_TYPE] = React.createElement(FormattedMessage, { id: "ui-lists.lists.columns.record-type" }),
    _a[COLUMNS_NAME.RECORDS] = React.createElement(FormattedMessage, { id: "ui-lists.lists.columns.records" }),
    _a[COLUMNS_NAME.STATUS] = React.createElement(FormattedMessage, { id: "ui-lists.lists.columns.status" }),
    _a[COLUMNS_NAME.SOURCE] = React.createElement(FormattedMessage, { id: "ui-lists.lists.columns.source" }),
    _a[COLUMNS_NAME.LAST_UPDATED] = React.createElement(FormattedMessage, { id: "ui-lists.lists.columns.last-updated" }),
    _a[COLUMNS_NAME.VISIBILITY] = React.createElement(FormattedMessage, { id: "ui-lists.lists.columns.visibility" }),
    _a);
